import React, { useState } from "react";
import { useSelector } from "react-redux";
import RepairRecycleBin from "../../User/components/UserDashboardComponents/Repair/Repair-recycleBin";
import RecycleBin from "./RecycleBin";

const MainRecycleBin = () => {
  const [activeTab, setActiveTab] = useState("po");

  const repairDeletedCount = useSelector(
    (state: any) => state.recycleRepair?.items?.length || 0
  );

  const poDeletedCount = useSelector(
    (state: any) => state.recycleBin?.orders?.length || 0
  );

  return (
    <div className="p-4 flex flex-col gap-6">      
         {/* Tabs */}
      <div className="flex gap-3 border-b-2 border-gray-200">
        
        {/* PO Tab */}
        <button
          className={`relative px-6 py-3 rounded-t-lg font-semibold flex items-center gap-3 transition-all duration-200 ${
            activeTab === "po"
              ? "bg-black text-white shadow-lg  -mb-0.5 border-b-2 "
              : "bg-white text-gray-600 hover:bg-gray-50 hover:text-gray-800 border border-gray-200 border-b-0"
          }`}
          onClick={() => setActiveTab("po")}
        >
          <span>PO Recycle Bin</span>
          <span className={`text-xs font-bold px-2.5 py-1 rounded-full transition-colors ${
            activeTab === "po"
              ? "bg-white text-indigo-600"
              : "bg-rose-500 text-white"
          }`}>
            {poDeletedCount}
          </span>
        </button>

        {/* Repair Tab */}
        <button
          className={`relative px-6 py-3 rounded-t-lg font-semibold flex items-center gap-3 transition-all duration-200 ${
            activeTab === "repair"
              ? "bg-black text-white shadow-lg  -mb-0.5 border-b-2 "
              : "bg-white text-gray-600 hover:bg-gray-50 hover:text-gray-800 border border-gray-200 border-b-0"
          }`}
          onClick={() => setActiveTab("repair")}
        >
          <span>Repair Recycle Bin</span>
          <span className={`text-xs font-bold px-2.5 py-1 rounded-full transition-colors ${
            activeTab === "repair"
              ? "bg-white text-indigo-600"
              : "bg-rose-500 text-white"
          }`}>
            {repairDeletedCount}
          </span>
        </button>

      </div>

      {/* Tab Content */}
      <div className="mt-2">
        {activeTab === "po" && <RecycleBin />}
        {activeTab === "repair" && <RepairRecycleBin />}
      </div>
    </div>
  );
};

export default MainRecycleBin;